// src/onboarding/OnbBee.jsx
// Phase 37 — extracted from src/App.jsx (Plan 37-03).

export default function OnbBee({ top = 140, delay = 0 }) {
  return (
    <svg aria-hidden="true" className="onb-bee" width="18" height="14" viewBox="0 0 18 14"
         style={{
           position: "absolute", top, left: -30, zIndex: 5,
           animation: `onb-bee-path 14s ${delay}s linear infinite`,
         }}>
      <defs>
        <linearGradient id="beeBody" x1="0" x2="1">
          <stop offset="0" stopColor="#f0c840"/>
          <stop offset="0.5" stopColor="#3a2a18"/>
          <stop offset="1" stopColor="#f0c840"/>
        </linearGradient>
      </defs>
      <ellipse cx="9" cy="7" rx="6" ry="3.5" fill="url(#beeBody)"/>
      <ellipse cx="7" cy="4" rx="3" ry="2" fill="rgba(255,255,255,0.8)"/>
      <ellipse cx="11" cy="4" rx="3" ry="2" fill="rgba(255,255,255,0.8)"/>
    </svg>
  );
}
